import { useEffect } from "react";
import { useCartStore } from "../store/cartStore";
import { getCart, addToCart, transformProductsToCartItems } from "../services/cartService";

// Вынесенная логика глобальной синхронизации корзины
export function useGlobalCartSync() {
  const isLoggedIn = !!localStorage.getItem("token");
  const { setCart } = useCartStore();

  useEffect(() => {
    const syncCart = async () => {
      try {
        if (isLoggedIn) {
          // 1. Локальная корзина (если хотите "досыпать" гостевые товары на сервер)
          const localCart = JSON.parse(localStorage.getItem("cart") || "[]");

          // 2. Берём серверную корзину
          const serverRes = await getCart();
          const serverCart = serverRes.result;

          // Сливаем
          for (const localItem of localCart) {
            const foundOnServer = serverCart.find(
              (srvItem) => srvItem.id === localItem.id // Use 'id' instead of 'product_id'
            );
            if (foundOnServer) {
              const delta = localItem.quantity - (foundOnServer.quantity ?? 0);
              if (delta > 0) {
                await addToCart(localItem.id, delta); // Use 'id' instead of 'product_id'
              }
            } else {
              await addToCart(localItem.id, localItem.quantity); // Use 'id' instead of 'product_id'
            }
          }

          // 3. Финальный запрос + очистка localStorage
          const updatedRes = await getCart();
          setCart(transformProductsToCartItems(updatedRes.result));
          localStorage.removeItem("cart");
        } else {
          // Если гость — просто подгружаем данные из localStorage
          const localCart = JSON.parse(localStorage.getItem("cart") || "[]");
          // Преобразуем локальные данные в CartItem[]
          const transformedLocalCart = localCart.map((item: any) => ({
            ...item,
            quantity: item.quantity || 1,
            available_quantity: item.stock_quantity,
            current_warehouse_id: item.current_warehouse_id,
            is_low_stock: false
          }));
          setCart(transformedLocalCart);
        }
      } catch (err) {
        console.error("Ошибка глобальной синхронизации корзины:", err);
      }
    };

    syncCart();
  }, [isLoggedIn, setCart]);
}